const zoid = require('zoid/dist/zoid');

import {
  WidgetConfig,
  XProps,
  Widget,
  WidgetEventListener,
  WidgetEvent,
  WidgetType,
} from './interface';
import type { RegistrationWidget } from './widgets/RegistrationWidget';
import { getWidgetUrl } from './utils/getWidgetUrl';
import { getIframeSize } from './utils/getIframeSize';
import config from '../../config';

type ZoidWidget = (
  zoidConfig: WidgetConfig & {
    on: (listener: WidgetEventListener) => void;
    emit: (event: WidgetEvent) => void;
  }
) => Widget;

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    myWidget: Widget;
    xprops: XProps;
    eWebinarWidget: ZoidWidget;
    eWebinarWidgetInstance: RegistrationWidget;
    ewListenerInited: boolean;
    grecaptcha: any;
    ewInit: () => void;
  }
}

export const createWidget = (): ZoidWidget => {
  return zoid.create({
    tag: 'ewebinar-widget',
    url: ({ props }: { props: WidgetConfig }): string => {
      const distUrl = new URL(window.location.href);
      const formUrl = new URL(getWidgetUrl(props));
      distUrl.searchParams.forEach((key, value) => formUrl.searchParams.set(value, key));
      if (props.source) {
        formUrl.searchParams.set('source', props.source);
      }
      if (props.isMobile) {
        formUrl.searchParams.set('ewIsMobile', '1');
      }
      formUrl.searchParams.set('widgetType', props.type);
      return formUrl.href;
    },
    dimensions: ({ props }: { props: WidgetConfig }) => {
      if (props.type === WidgetType.EmbeddedPlayer) {
        return {
          width: `${window.innerWidth - 20}px`,
          height: `${window.innerHeight - 60}px`,
        };
      }
      return getIframeSize();
    },
    props: {
      on: {
        type: 'function',
      },
      emit: {
        type: 'function',
      },
    },
    attributes: ({ props }: { props: WidgetConfig }) => {
      let domain = config.MAIN_FRONTEND_URL;
      try {
        const url = new URL(props.shortUrl ?? props.url);
        domain = url.origin;
      } catch {
        // use config domain
      }
      return {
        iframe: {
          allow: ['autoplay', 'encrypted-media', 'fullscreen']
            .map((feature) => {
              return `${feature} ${domain}`;
            })
            .join('; '),
        },
      };
    },
    autoResize: {
      height: false,
      width: false,
    },
    prerenderTemplate: function containerTemplate(): null {
      return null;
    },
  });
};

export default createWidget;
